<footer fxLayout="row" fxLayoutAlign="start">
	<div fxFlex="" fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="20px">
		<a href="https://www.alberta.ca/usingthissite.aspx" target="_blank">Using Alberta.ca</a>
		<a href="https://www.alberta.ca/disclaimer.aspx" target="_blank">Disclaimer</a>
		<a href="https://www.alberta.ca/privacystatement.aspx" target="_blank">Privacy</a>
		<a href="https://www.alberta.ca/accessibility.aspx" target="_blank">Accessibility</a>
	</div>
	<div>
		<span fxFlex="" class="footer-copyright">© 2021 Government of Alberta</span>
	</div>
</footer>
